import { PageSection } from "../../components/PageSection";

import { PlayPortrait } from "./PlayPortrait";

export const Play = () => {
  return (
    <PageSection darkMode portrait={<PlayPortrait />}>
      <h2>For Fun</h2>
      <p>
        When I'm not writing some sweet JavaScript or trouble-shooting a
        stubborn bit of CSS, I can often be found reading a novel (
        <a
          href="https://en.wikipedia.org/wiki/Terry_Pratchett"
          target="_blank"
          rel="noreferrer"
        >
          Terry Pratchett
        </a>{" "}
        is a favorite of mine), getting my sweat on (I used to own a gym!), or
        playing with{" "}
        <a
          href="https://www.instagram.com/figgyandcedric/"
          target="_blank"
          rel="noreferrer"
        >
          my dogs
        </a>
        .
      </p>
      <p>
        If you're in Brooklyn, you can often find me grabbing a coffee from{" "}
        <a
          href="https://www.instagram.com/brooklynperkcoffee/"
          target="_blank"
          rel="noreferrer"
        >
          Brooklyn Perk
        </a>{" "}
        or wandering around{" "}
        <a
          href="https://www.prospectpark.org/"
          target="_blank"
          rel="noreferrer"
        >
          Prospect Park
        </a>{" "}
        (especially during off-leash hours!). On the weekends, my wife and I
        like to climb at{" "}
        <a
          href="https://gowanus.thecliffsclimbing.com/"
          target="_blank"
          rel="noreferrer"
        >
          The Cliffs
        </a>{" "}
        and then have a burger and a beer at{" "}
        <a
          href="https://threesbrewing.com/locations/gowanus/"
          target="_blank"
          rel="noreferrer"
        >
          Three's Brewing
        </a>
        .
      </p>
    </PageSection>
  );
};
